import moment from 'moment';
import createCachedSelector from 're-reselect';

import { DatesIntervalEditorState } from '../../typings/datesInterval';
import { State } from '../../typings/state';

export const selectStartDateFromDatesIntervalEditor = createCachedSelector(
    (state: State, id: string) => state.datesIntervalEditor[id],
    (datesIntervalEditor: DatesIntervalEditorState) => {
        const nowDate = moment(Date.now()).startOf('day');
        const defaultDateIntervalEditor = {
            startDate: nowDate
        };

        const { startDate, minDate, maxDate } = datesIntervalEditor || defaultDateIntervalEditor;

        return {
            date: startDate || nowDate,
            minDate: minDate || nowDate,
            maxDate: maxDate
        };
    }
)((state: State, id: string) => id);

export const selectEndDateFromDatesIntervalEditor = createCachedSelector(
    (state: State, id: string) => {
        return state.datesIntervalEditor[id];
    },
    (datesIntervalEditor: DatesIntervalEditorState) => {
        if (!datesIntervalEditor) {
            return;
        }

        const nowDate = moment(Date.now()).startOf('day');
        const { startDate, endDate, maxDate } = datesIntervalEditor;

        if (!endDate) {
            return;
        }

        return {
            date: endDate,
            minDate: moment.max(nowDate, startDate),
            maxDate: maxDate
        };
    }
)((state: State, id: string) => id);

export const selectStartTimeFromDatesIntervalEditor = createCachedSelector(
    (state: State, id: string) => state.datesIntervalEditor[id],
    (datesIntervalEditor: DatesIntervalEditorState) => {
        return datesIntervalEditor && datesIntervalEditor.startTime;
    }
)((state: State, id: string) => id);

export const selectEndTimeFromDatesIntervalEditor = createCachedSelector(
    (state: State, id: string) => state.datesIntervalEditor[id],
    (datesIntervalEditor: DatesIntervalEditorState) => {
        return datesIntervalEditor && datesIntervalEditor.endTime;
    }
)((state: State, id: string) => id);

export const selectDataFromDatesIntervalEditor = createCachedSelector(
    selectStartDateFromDatesIntervalEditor,
    selectStartTimeFromDatesIntervalEditor,
    selectEndDateFromDatesIntervalEditor,
    selectEndTimeFromDatesIntervalEditor,
    (startDate, startTime, endDate, endTime) => {
        return {
            startDate,
            startTime,
            endDate,
            endTime
        };
    }
)((state: State, id: string) => id);
